import firebaseApp from "../firebase/credenciales";
import { getFirestore, collection, doc, setDoc } from "firebase/firestore";
import Swal from 'sweetalert2'
import escribirLog from "./escribirLog";

async function editarUpload(infoProducto, autor, baseDatos) {
  const db = getFirestore(firebaseApp);

  if (!baseDatos) {
    console.error("No se puede guardar: baseDatos está vacío");
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'No se puede guardar: baseDatos está vacío',
    });
    return;
  }

  const collectionRef = collection(db, baseDatos);
  // El ID se genera en el cliente para persistir el documento y su campo `id`
  // en UNA sola escritura (antes: addDoc + updateDoc = dos viajes a Firestore).
  const docRef = doc(collectionRef);

  await setDoc(docRef, {
    ...infoProducto,
    id: docRef.id,
  });

  if(docRef.id.length >= 20){
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: 'Documento registrado correctamente',
      showConfirmButton: false,
      timer: 2500
    })
  } else {
    Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: 'Error al registrar el documento',
      showConfirmButton: false,
      timer: 2500
    })
  }
  escribirLog("Edición", infoProducto, autor);
}

export default editarUpload;
